/** Resolution events and HTTP snapshots can arrive in either order. */
export class ResolutionStore {
  private states = new Map<string, { resolved: boolean; version: number }>();
  remember(id: string, resolved: boolean, version: number): void {
    if (!Number.isSafeInteger(version) || version < 0) return;
    const current = this.states.get(id);
    if (!current || version > current.version) this.states.set(id, { resolved, version });
  }
  get(id: string): { resolved: boolean; version: number } | undefined { return this.states.get(id); }
}
